import { Component } from '@angular/core';
import { Local } from './shares/constants';
import { TranslateHelpersService } from './shares/helpers';
import { LanguageService } from './shares/services';
import { SignalrService } from './shares/services/signalr.service';

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet><nz-spin id="hl-loading" class="loading-data" nzSimple nzSize="large"></nz-spin>'
})
export class AppComponent {
  constructor(translate: TranslateHelpersService,public signalrService: SignalrService) {
    translate.defaultLang();
  }

  ngOnInit(){
    const user = localStorage.getItem(Local.User);
    if(user){
      this.signalrService.startConnection();
    }
  }
}
